package com.trevorwiebe.timesheet.mileage.data.dto

import com.trevorwiebe.timesheet.mileage.domain.model.Equipment
import com.trevorwiebe.timesheet.mileage.domain.model.EquipmentType
import kotlinx.serialization.Serializable

@Serializable
data class EquipmentDto(
    val unitNumber: String = "",
    val type: String = "",
    val active: Boolean = true,
    val serviceInterval: Int = 0,
    val serviceWarningMiles: Int = 2000,
    val deleted: Boolean = false
)

fun EquipmentDto.toEquipment(id: String) = Equipment(
    id = id,
    unitNumber = unitNumber,
    type = EquipmentType.valueOf(type),
    active = active,
    serviceInterval = serviceInterval.toLong(),
    serviceWarningMiles = serviceWarningMiles.toLong(),
    deleted = deleted
)

fun Equipment.toEquipmentDto() = EquipmentDto(
    unitNumber = unitNumber,
    type = type.name,
    active = active,
    serviceInterval = serviceInterval.toInt(),
    serviceWarningMiles = serviceWarningMiles.toInt(),
    deleted = deleted
)
